import * as api from '../../constants/api'
import callApi from '../http'

const operatorRefueling = async (body) => await callApi(api.OPERATOR_REFUELING, body)

const requestDetails = async (body) => await callApi(api.OPERATOR_REQUEST_DETAILS, body)

const statusFuelRequest = async (body) => await callApi(api.FUEL_REQUEST_STATUS, body)

const operatorCompleteRequest = async (body) => await callApi(api.OPERATOR_COMPLETE_REQUEST, body)

const operatorFuelRequestHistory = async (body) => await callApi(api.OPERATOR_FUEL_REQUEST_HISTORY, body)

const volumeReceivedConfirmation = async (body) => await callApi(api.VOLUME_RECEIVED_CONFIRMATION, body)

const operatorRequestInprocessList = async (body) => await callApi(api.OPERATOR_REQUEST_INPROCESS_LIST, body)

const viewFuelRequestOnlineByOperator = async (body) => await callApi(api.VIEW_FUEL_REQUEST_ONLINE_BY_OPERATOR, body)

export {
    requestDetails,
    operatorRefueling,
    statusFuelRequest,
    operatorCompleteRequest,
    operatorFuelRequestHistory,
    volumeReceivedConfirmation,
    operatorRequestInprocessList ,
    viewFuelRequestOnlineByOperator
}